import { render, staticRenderFns } from "./LandingNavbar.vue?vue&type=template&id=2090f55e&scoped=true&"
import script from "./LandingNavbar.vue?vue&type=script&lang=js&"
export * from "./LandingNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2090f55e",
  null
  
)

export default component.exports